package org.gstechnovos.jexonplastech.sections.home.sections

import androidx.compose.runtime.Composable
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaData
import org.gstechnovos.jexonplastech.components.widgets.GlobalCtaWidget

// ==========================================
// CMS DATA MODEL
// ==========================================

/**
 * 
 * Headline: Limit to 1 line (e.g., "Partner With Us for Bulk Distribution").
 *
 * Description: Limit to 2 sentences to maintain a high conversion rate without visually overwhelming
 * the user.
 *
 * Button Text: Limit to 3-4 words (e.g., "Inquire About Bulk Orders").
 *
 */
val defaultHomeCtaData = GlobalCtaData(
    headline = "Partner With Us for Bulk Distribution",
    description = "Ready to scale your inventory with premium, durable homeware? Contact our manufacturing team today for B2B pricing, custom runs, and global vendor opportunities.",
    buttonText = "Inquire About Bulk Orders",
    buttonPath = "/contact"
)

// ==========================================
// COMPONENT
// ==========================================

@Composable
fun HomeGlobalCtaSection(data: GlobalCtaData = defaultHomeCtaData) {
    // Simply render the global widget using this section's specific data
    GlobalCtaWidget(data = data)
}